module.exports = __webpack_public_path__ + "static/media/desktop.8d24dbad.png";